<template>
  <div class="plugin-app">
    <router-view></router-view>
  </div>
</template>

<script>
import {init$http} from '../apis/index';

export default {
  name: 'App',
  inject: ['$http'],
  created() {
    init$http(this.$http);
  }
};
</script>

<style lang="scss">
.plugin-select-custom-dialog {
  .el-dialog__body {
    height: 200px;
    overflow-y: auto;
  }
}
</style>

<style lang="scss" scoped>
.plugin-app {
  height: 100%;
}
</style>
